import { Divider, Spin } from 'antd';
import images from 'assets/sheets/images';
import Button from 'components/Button';
import CustomTable from 'components/CustomTable/CustomTable';
import Input from 'components/Input/Input';
import Select from 'components/Select';
import {
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
  TIME_ZONE,
} from 'helper/init.constants';
import React, { useCallback, useEffect, useState } from 'react';
import { CeuManagementStyled } from './styled';
import Pagination from 'components/Pagination';
import ChooseDate from 'components/ChooseDate/ChooseDate';
import ModalConfirmDeleteCEU from './components/ConfirmDeletePopup';
import ModalImportCSV from './components/ModalImportCSV';
import AddCEUPopup from './components/AddCEUPopup';
import CeuServices from 'services/CeuServices';
import { clearAllFields } from 'pages/CourseSchedule';
import { toast } from 'sonner';
import { NO_INTERNET } from 'components/messageError';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
// import Encoding from "encoding-japanese";

const CEUSelectorData = [
  {
    label: 'QR付与',
    value: 'QR',
  },
  {
    label: ' 一括付与',
    value: 'BATCH',
  },
  {
    label: '個別付与',
    value: 'INDIVIDUAL',
  },
  {
    label: '審査申請',
    value: 'REVIEW_APPLICATION',
  },
  {
    label: '修正付与',
    value: 'CORRECTION',
  },
];

const initsState = {
  search: '',
  grantType: 'ALL',
  startTime: '',
  endTime: '',
  page: DEFAULT_PAGE_NUMBER,
  pageSize: DEFAULT_PAGE_SIZE,
  timezone: TIME_ZONE,
};

const CeuManagement = () => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ ...initsState });
  const [isOpenPopupDelete, setIsOpenPopupDelete] = useState(false);
  const [listCeu, setListCeu] = useState([]);
  const [isOpenPopupImportCEU, setIsOpenPopupImportCEU] = useState(false);
  const [isOpenPopupAddCEU, setIsOpenPopupAddCEU] = useState({
    state: false,
    id: null,
  });

  const columns = [
    {
      title: '会員ID',
      dataIndex: 'id',
      fixed: 'left',
      key: 'id',
      width: 95,
      render: (_, record) => {
        return <div>{record.user.memberId}</div>;
      },
    },
    {
      title: '名前',
      dataIndex: 'name',
      fixed: 'left',
      key: 'name',
      width: 135,
      render: (_, record) => {
        return <div>{record.user?.name}</div>;
      },
    },
    {
      title: 'メールアドレス',
      dataIndex: 'email',
      fixed: 'left',
      key: 'email',
      width: 250,
      render: (_, record) => {
        return <div>{record.user.email}</div>;
      },
    },
    {
      title: '付与CEU数',
      dataIndex: 'ceuAwarded',
      key: 'ceuAwarded',
      width: 134,
      render: (points) => <span>{Number(points) > 0 ? `+${points}` : `${points}`}</span>,
    },
    {
      title: '付与日',
      dataIndex: 'checkinTime',
      key: 'checkinTime',
      width: 134,
      render: (_, record) => {
        return <div>{dayjs(record.checkinTime).format('YYYY/MM/DD')}</div>;
      },
    },
    {
      title: 'CEU付与種別',
      dataIndex: 'grantType',
      key: 'grantType',
      width: 129,
      render: (_, record) => {
        return <div>{CEUSelectorData.find((item) => item.value === record.grantType).label}</div>;
      },
    },
    {
      title: 'カテゴリー',
      dataIndex: 'subCategory',
      key: 'subCategory',
      width: 211,
      render: (_, record) => {
        return <div>{record.name}</div>;
      },
    },
    {
      title: 'メモ',
      dataIndex: 'note',
      key: 'note',
      width: 220,
    },
    {
      title: '更新者',
      dataIndex: 'updatedByName',
      key: 'updatedByName',
      width: 121,
      render: (_, record) => {
        return <div>{record.grantType !== 'QR' && record.updatedByName}</div>;
      },
    },
    {
      title: '更新日時',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 133,
      render: (_, record) => {
        return (
          <div>{record.grantType !== 'QR' && dayjs(record.updatedAt).format('YYYY/MM/DD')}</div>
        );
      },
    },
    {
      title: 'アクション',
      dataIndex: '',
      width: 125,
      render: (record) => {
        return (
          <div className="flex gap-2">
            <div
              onClick={() =>
                setIsOpenPopupAddCEU({
                  state: true,
                  value: record._id,
                })
              }
              className="flex h-[36px] w-[36px] items-center justify-center rounded-[8px] border border-[#E6EBF1] bg-white hover:cursor-pointer"
            >
              <images.edit.src />
            </div>
            <div
              onClick={() => handleOpenPopupDelete(record)}
              className={`flex h-[36px] w-[36px] items-center justify-center rounded-[8px] border border-[#E6EBF1] bg-white hover:cursor-pointer`}
            >
              <images.delete.src />
            </div>
          </div>
        );
      },
    },
  ];

  const handleOpenPopupDelete = (record) => {
    setIsOpenPopupDelete(record._id);
  };

  const handleChangeData = ({ label, value }) => {
    setForm({
      ...form,
      [label]: value,
    });
  };

  const handleChangePage = (page, pageSize) => {
    const body = clearAllFields({
      ...form,
      startTime: form.startTime || '',
      endTime: form.endTime || '',
      page,
      pageSize,
    });

    setForm(body);
    getListCeus(body);
  };

  const handleAcceptDate = (e) => {
    // Only handle the click if it's from the calendar panel
    if (e?.target?.closest('.ant-picker-panel-container')) {
      const { start, end } = form;
      const dateRegex = /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/;

      // If both dates are present and valid, update the form
      if (start && end && dateRegex.test(start) && dateRegex.test(end)) {
        // Trigger search with the selected dates
        setForm((prev) => ({
          ...prev,
          startTime: start,
          endTime: end,
        }));
      } else {
        // Clear the dates if they're not valid
        setForm((prev) => ({
          ...prev,
          startTime: '',
          endTime: '',
        }));
      }
    }
  };

  // const handleExportData = () => {
  //   setLoading(true);
  //   CeuServices.getListCeu(
  //     clearAllFields({
  //       ...form,
  //       isAll: 1,
  //     }),
  //   )
  //     .then(async (res) => {
  //       const items = res?.data?.items || [];

  //       const dataExport = items.map((item) => {
  //         return {
  //           会員ID: item.user.memberId,
  //           名前: item.user.name,
  //           メールアドレス: item.user.email,
  //           付与CEU数:
  //             Number(item.ceuAwarded) && Number(item.ceuAwarded) > 0
  //               ? `+${item.ceuAwarded}`
  //               : item.ceuAwarded,
  //           付与日: `="${dayjs(item.checkinTime).format('YYYY/MM/DD')}"`,
  //           CEU付与種別: CEUSelectorData.find((i) => i.value === item.grantType)?.label || '',
  //           カテゴリー: item.name,
  //           メモ: item.note,
  //           更新者: CEUSelectorData.find(
  //             (i) => i.value === item.grantType && item.grantType !== 'QR',
  //           )?.label
  //             ? item.updatedByName
  //             : '',
  //           更新日時:
  //             item.grantType !== 'QR' ? `="${dayjs(item.updatedAt).format('YYYY/MM/DD')}"` : '',
  //         };
  //       });

  //       const headers = [
  //         '会員ID',
  //         '名前',
  //         'メールアドレス',
  //         '付与CEU数',
  //         '付与日',
  //         'CEU付与種別',
  //         'カテゴリー',
  //         'メモ',
  //         '更新者',
  //         '更新日時',
  //       ];

  //       const ws = XLSX.utils.json_to_sheet(dataExport.length > 0 ? dataExport : [], {
  //         header: headers,
  //       });

  //       const range = XLSX.utils.decode_range(ws['!ref']);
  //       for (let R = range.s.r; R <= range.e.r; ++R) {
  //         for (let C = range.s.c; C <= range.e.c; ++C) {
  //           const cell_address = XLSX.utils.encode_cell({ c: C, r: R });
  //           if (!ws[cell_address]) continue;

  //           if (C === 4 || C === 9) {
  //             if (!ws[cell_address].s) ws[cell_address].s = {};
  //             ws[cell_address].s.numFmt = '@'; // Text format
  //           }
  //         }
  //       }

  //       const csv = XLSX.utils.sheet_to_csv(ws, { FS: ',', strip: true });

  //       const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

  //       saveAs(blob, `dataCEUExport.csv`);
  //     })
  //     .catch((err) => {
  //       toast.error(err.message || err || NO_INTERNET);
  //     })
  //     .finally(() => setLoading(false));
  // };

  const handleExportDataVer2 = () => {
    setLoading(true);

    CeuServices.getListCeu(
      clearAllFields({
        ...form,
        isAll: 1,
      }),
    )
      .then(async (res) => {
        const items = res?.data?.items || [];

        const dataExport = items.map((item) => {
          return {
            会員ID: item.user.memberId,
            名前: item.user.name,
            メールアドレス: item.user.email,
            付与CEU数:
              Number(item.ceuAwarded) && Number(item.ceuAwarded) > 0
                ? `+${item.ceuAwarded}` || 0
                : item.ceuAwarded || 0,
            付与日: dayjs(item.checkinTime).format('YYYY/MM/DD'),
            CEU付与種別: CEUSelectorData.find((i) => i.value === item.grantType)?.label || 0,
            カテゴリー: item.name,
            メモ: item.note,
            更新者: CEUSelectorData.find(
              (i) => i.value === item.grantType && item.grantType !== 'QR',
            )?.label
              ? item.updatedByName
              : '',
            更新日時: item.grantType !== 'QR' ? dayjs(item.updatedAt).format('YYYY/MM/DD') : '',
          };
        });

        const headers = [
          '会員ID',
          '名前',
          'メールアドレス',
          '付与CEU数',
          '付与日',
          'CEU付与種別',
          'カテゴリー',
          'メモ',
          '更新者',
          '更新日時',
        ];

        const ws = XLSX.utils.json_to_sheet(dataExport.length > 0 ? dataExport : [], {
          header: headers,
        });

        // Set column widths for better readability
        ws['!cols'] = [
          { wch: 12 }, // 会員ID
          { wch: 15 }, // 名前
          { wch: 25 }, // メールアドレス
          { wch: 12 }, // 付与CEU数
          { wch: 12 }, // 付与日
          { wch: 15 }, // CEU付与種別
          { wch: 20 }, // カテゴリー
          { wch: 20 }, // メモ
          { wch: 15 }, // 更新者
          { wch: 12 }, // 更新日時
        ];

        // Force date columns as text format
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let R = range.s.r; R <= range.e.r; ++R) {
          for (let C = range.s.c; C <= range.e.c; ++C) {
            const cell_address = XLSX.utils.encode_cell({ c: C, r: R });
            if (!ws[cell_address]) continue;

            // Apply text format to date columns (付与日 and 更新日時)
            if (C === 4 || C === 9) {
              if (!ws[cell_address].s) ws[cell_address].s = {};
              ws[cell_address].s.numFmt = '@'; // Text format
              ws[cell_address].t = 's'; // Force as string type
            }
          }
        }

        // Convert to CSV
        const csv = XLSX.utils.sheet_to_csv(ws, {
          FS: ',',
          strip: false,
        });

        // Convert to Shift-JIS (CP932) encoding for Excel compatibility
        const unicodeArray = [];
        for (let i = 0; i < csv.length; i++) {
          unicodeArray.push(csv.charCodeAt(i));
        }

        const BOM = '\uFEFF';

        const blob = new Blob([BOM + csv], {
          type: 'text/csv;charset=shift-jis;',
        });

        saveAs(blob, 'dataCEUExport.csv');
      })
      .catch((err) => {
        toast.error(err.message || err || NO_INTERNET);
      })
      .finally(() => setLoading(false));
  };

  const handleDateChange = (dates, dateStrings) => {
    // dateStrings comes formatted by RangePicker per `format` prop (YYYY/MM/DD)
    if (!dates || !dateStrings) {
      setForm((prev) => ({
        ...prev,
        startTime: '',
        endTime: '',
        page: DEFAULT_PAGE_NUMBER,
        pageSize: DEFAULT_PAGE_SIZE,
      }));
      return;
    }

    const [start, end] = dateStrings;
    setForm((prev) => ({
      ...prev,
      startTime: start || '',
      endTime: end || '',
    }));
  };

  const getListCeus = useCallback((params) => {
    setLoading(true);
    return CeuServices.getListCeu(clearAllFields(params))
      .then((res) => {
        if (res.isOk) {
          setListCeu(res.data);
        }
      })
      .catch((err) => toast.error(err?.message || err || NO_INTERNET))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    getListCeus(initsState);
  }, []);

  const handleSearch = () => {
    const body = clearAllFields({
      search: form.search || '',
      grantType: form.grantType || 'ALL',
      startTime: form.startTime || '',
      endTime: form.endTime || '',
      page: DEFAULT_PAGE_NUMBER,
      pageSize: DEFAULT_PAGE_SIZE,
    });
    setForm({
      ...body,
    });
    setLoading(true);
    CeuServices.getListCeu(clearAllFields(body))
      .then((res) => {
        if (res.isOk) {
          setListCeu(res.data);
        }
      })
      .catch((err) => toast.error(err?.message || err || NO_INTERNET))
      .finally(() => setLoading(false));
  };

  return (
    <CeuManagementStyled>
      <Spin spinning={loading}>
        <div className="mb-4 flex h-10 items-center justify-end xl:h-24">
          <div className="flex w-max items-center justify-end gap-4 xl:h-24 xl:flex-col xl:gap-4">
            <div className="hidden xl:flex xl:h-10 xl:w-full xl:justify-end 2xl:flex 2xl:h-10 2xl:w-full 2xl:justify-end">
              <Input
                placeholder="名前、メールアドレス、会員ID"
                isPopup={false}
                $autoTrim={true}
                width={360}
                className="hidden xl:flex xl:h-10 xl:!max-w-[1000px] xl:justify-end 2xl:flex 2xl:h-10 2xl:max-w-[1000px] 2xl:justify-end"
                classNameInput="xl:w-full"
                height={40}
                value={form.search}
                onChange={(e) => handleChangeData({ label: 'search', value: e })}
              />
            </div>
            <div className="list-member-header flex w-full items-center justify-end gap-4">
              <Input
                placeholder="名前、メールアドレス、会員ID"
                isPopup={false}
                $autoTrim={true}
                width={360}
                className="xl:!hidden 2xl:!hidden"
                classNameInput="2xl:!max-w-[335px]"
                height={40}
                value={form.search}
                onChange={(e) => handleChangeData({ label: 'search', value: e })}
              />

              <Select
                label="CEU付与種別:"
                options={[
                  {
                    value: 'ALL',
                    label: '全て',
                  },
                  ...CEUSelectorData,
                ]}
                value={form.grantType || 'ALL'}
                $width={220}
                isPopup={false}
                $heightSelect={40}
                $widthLabel={100}
                onChange={(e) => handleChangeData({ label: 'grantType', value: e.value })}
                iconDown={images.icon.src}
              />
              <ChooseDate
                label="付与日:"
                start={form.startTime}
                end={form.endTime}
                onChange={handleDateChange}
                onSubmit={handleAcceptDate}
                width="100%"
                className="responsive-choose-date additional-styling !gap-2"
              />
              <Button width={84} height={40} btnType="outline" onClick={handleSearch}>
                <p style={{ letterSpacing: '0', fontWeight: 400 }}>検索</p>
              </Button>
            </div>
          </div>
        </div>
        <Divider className="mb-4" />

        <div className="mb-4 flex items-center justify-between">
          <div className="flex w-max items-center justify-start gap-4">
            <Button
              btnType="primary"
              width={120}
              height={40}
              onClick={() =>
                setIsOpenPopupAddCEU({
                  state: true,
                  value: null,
                })
              }
            >
              <p style={{ letterSpacing: '0', fontWeight: 400 }}>個別付与</p>
            </Button>
            <Button
              btnType="primary"
              width={120}
              height={40}
              onClick={() => setIsOpenPopupImportCEU(true)}
            >
              <p style={{ letterSpacing: '0', fontWeight: 400 }}>一括付与</p>
            </Button>
          </div>
          <Button width={160} height={40} btnType="back" onClick={handleExportDataVer2}>
            <p
              style={{
                letterSpacing: '0',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <images.download.src width={20} height={20} />
              ダウンロード
            </p>
          </Button>
        </div>

        <CustomTable
          columns={columns}
          dataSource={listCeu?.items || []}
          scrollX={1200}
          sticky={{ offsetHeader: 0 }}
          rowKey="_id"
        />

        <div className="mt-6 flex w-full items-center justify-end">
          <Pagination
            total={listCeu?.count ?? 0}
            pageSize={form.pageSize || DEFAULT_PAGE_SIZE}
            page={form.page || DEFAULT_PAGE_NUMBER}
            onChangePage={handleChangePage}
          />
        </div>

        <ModalConfirmDeleteCEU
          isOpen={!!isOpenPopupDelete}
          id={isOpenPopupDelete}
          onCancel={() => setIsOpenPopupDelete(null)}
          onSuccess={() => {
            const currentPageItems = listCeu?.items?.length || 0;
            const shouldGoBack = currentPageItems === 1 && form.page > 1;

            const newPage = shouldGoBack ? form.page - 1 : form.page;
            const updatedForm = {
              ...form,
              page: newPage,
            };

            setForm(updatedForm);
            getListCeus(clearAllFields(updatedForm));
          }}
        />

        <ModalImportCSV
          isOpen={isOpenPopupImportCEU}
          onCancel={() => setIsOpenPopupImportCEU(false)}
          onSuccess={() => {
            const body = {
              search: '',
              page: DEFAULT_PAGE_NUMBER,
              pageSize: DEFAULT_PAGE_SIZE,
            };
            setForm(body);
            getListCeus(body);
          }}
        />

        <AddCEUPopup
          isOpen={!!isOpenPopupAddCEU.state}
          id={isOpenPopupAddCEU.value}
          onCancel={() =>
            setIsOpenPopupAddCEU({
              state: false,
              value: null,
            })
          }
          onSuccess={() => {
            setForm({
              search: '',
              page: DEFAULT_PAGE_NUMBER,
              pageSize: DEFAULT_PAGE_SIZE,
            });
            getListCeus({
              search: '',
              page: DEFAULT_PAGE_NUMBER,
              pageSize: DEFAULT_PAGE_SIZE,
            });
          }}
          onSuccessEdit={() => {
            setForm({
              ...form,
            });
            getListCeus({
              ...form,
            });
          }}
        />
      </Spin>
    </CeuManagementStyled>
  );
};

export default CeuManagement;
